module.exports = __webpack_public_path__ + "img/senalando.54d8f66c.png";